/* Shared colors for document interfaces and the trusted host's shadow DOM. */
:root, :host {
    color-scheme: light dark;
    --background-color: #fff;
    --text-color: #202122;
    --title-color: #101418;
    --border-color: #a2a9b1;
    --border-color-hover: #27292d;
    --link-color: #36c;
    --link-hover-color: #3056a9;
    --secondary-color: #54595d;
    --secondary-hover-color: #202122;
    --warning-color: #bf3c2c;
    --warning-hover-color: #9f3526;
    --background-color-interactive: #eaecf0;
    --background-color-interactive-hover: #dadde3;
    --accent-button-background: #36c;
    --accent-button-background-hover: #3056a9;
    --accent-button-text: #fff;
    --backdrop-color: rgb(255 255 255 / 0.8);
    --backdrop-subtle-color: rgb(255 255 255 / 0.4);
}

@media (prefers-color-scheme: dark) {
    :root, :host {
        color-scheme: dark;
        --background-color: #101418;
        --text-color: #eaecf0;
        --title-color: #f8f9fa;
        --border-color: #72777d;
        --border-color-hover: #a2a9b1;
        --link-color: #88a3e8;
        --link-hover-color: #a6bbf5;
        --secondary-color: #a2a9b1;
        --secondary-hover-color: #c8ccd1;
        --warning-color: #fd7865;
        --warning-hover-color: #fea898;
        --background-color-interactive: #27292d;
        --background-color-interactive-hover: #404244;
        --backdrop-color: rgb(0 0 0 / 0.8);
        --backdrop-subtle-color: rgb(0 0 0 / 0.4);
    }
}
